import axiosInstance from "auth/FetchInterceptor";
import {
  ROLE_API,
  GET_ALL_ROLE,
  CREATE_ROLE,
  UPDATE_ROLE,
} from "constants/ApiConstant";
const RoleService = {};

RoleService.getAllRole = function () {
  return axiosInstance.get(GET_ALL_ROLE, null);
};
RoleService.createRole = function (data) {
  return axiosInstance.post(CREATE_ROLE, data);
};
RoleService.updateRole = function (data) {
  return axiosInstance.put(UPDATE_ROLE, data);
};
RoleService.deleteRole = function (id) {
  return axiosInstance.delete(`${ROLE_API}/${id}`, null);
};

export default RoleService;
